import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';
import { TextareaChangeEventDetail } from '@ionic/core';
import { ChatActionEnum } from 'src/app/models/chat-action.enum';
import { FirebaseChat } from 'src/app/models/firebase-chat.model';
import { ChatroomService } from 'src/app/services/chatroom.service';
import { ControllerService } from 'src/app/services/controller.service';

@Component({
  selector: 'app-chatroom-footer',
  templateUrl: './chatroom-footer.component.html',
  styleUrls: ['./chatroom-footer.component.scss'],
})
export class ChatroomFooterComponent implements OnInit {
  @Input() chatroomId: string;
  @Output() scrollToBottom = new EventEmitter();

  repliedMessage: FirebaseChat;
  image_upload: string;

  chatActionEnum = ChatActionEnum;
  formMessage: FormGroup;

  isHoldingShift = false;

  footer_col_size = {
    plus: 0,
    camera: 0,
    image: 0,
    textarea: 10,
    send: 2,
  };

  constructor(
    private chatroomService: ChatroomService,
    private formBuilder: FormBuilder,
    private controllerService: ControllerService,
  ) {}

  ngOnInit() {
    this.formMessage = this.formBuilder.group({
      message: ['', Validators.compose([Validators.required])],
      image_upload: ['', Validators.compose([])],
    });
  }

  isMe(chat: FirebaseChat) {
    return this.chatroomService.isMe(chat);
  }

  closeReply() {
    this.repliedMessage = null;
    this.chatroomService.setRepliedMessage(null);
  }

  removeImage() {
    this.image_upload = null;
    this.chatroomService.setImageUpload(null);
    this.formMessage.get('image_upload').reset();
  }

  async onUploadImage() {
    const isNative = Capacitor.isNativePlatform();

    const image = await Camera.getPhoto({
      quality: 40,
      allowEditing: false,
      resultType: CameraResultType.Base64,
      source: isNative ? CameraSource.Prompt : CameraSource.Photos,
    });

    if (image.base64String.length > 2_000_000) {
      this.controllerService.presentToast({
        message: 'Ukuran file tidak boleh lebih dari 2MB',
        color: 'danger',
        duration: 3000,
      });
      return;
    }

    this.removeImage();
    this.formMessage.controls.image_upload.setValue(image.base64String);
    this.image_upload = `data:image/jpeg;base64,${image.base64String}`;
    this.chatroomService.setImageUpload(this.image_upload);
    this.chatroomService.setImageBase64(image.base64String);
  }

  focusChat(event: any) {
    this.footer_col_size = {
      plus: 0,
      camera: 0,
      image: 0,
      textarea: 10,
      send: 2,
    };
    this.scrollToBottom.emit();
  }

  async sendMessage() {
    const message = this.formMessage.value.message;

    await this.chatroomService.sendMessage(message, this.chatroomId, () => {
      this.formMessage.reset();
      this.repliedMessage = null;
      this.removeImage();
    });
  }

  onChatChange(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  blurChat(event: any) {
    this.footer_col_size = {
      plus: 0,
      camera: 0,
      image: 0,
      textarea: 10,
      send: 2,
    };
  }
}
